export function calculateFaceValue(
  quantity: number,
  nominalPrice: number
): number {
  return quantity * nominalPrice;
}

// Generates all semi-annual coupon payment dates from issueDate up to and
// including maturityDate (if it falls exactly on a 6-month boundary).
export function generateCouponSchedule(
  issueDate: string,
  maturityDate: string
): string[] {
  const issue = new Date(issueDate);
  const maturity = new Date(maturityDate);

  if (issue >= maturity) return [];

  const schedule: string[] = [];
  let year = issue.getFullYear();
  let month = issue.getMonth(); // 0-indexed

  // Advance by 6 months from issue date
  month += 6;
  if (month >= 12) {
    month -= 12;
    year += 1;
  }

  while (true) {
    const couponDate = new Date(year, month, issue.getDate());
    if (couponDate > maturity) break;
    schedule.push(couponDate.toISOString().slice(0, 10));
    month += 6;
    if (month >= 12) {
      month -= 12;
      year += 1;
    }
  }

  return schedule;
}

// Returns (coupon_rate / 100 / 2) * face_value, or null when either is <= 0.
export function calculateCouponAmount(
  couponRate: number,
  faceValue: number
): number | null {
  if (couponRate <= 0 || faceValue <= 0) return null;
  return (couponRate / 100 / 2) * faceValue;
}

// Returns dates from schedule that are >= today and <= today + 6 months.
export function getUpcomingPayments(schedule: string[]): string[] {
  const today = new Date().toISOString().slice(0, 10);
  const sixMonthsLater = new Date();
  sixMonthsLater.setMonth(sixMonthsLater.getMonth() + 6);
  const cutoff = sixMonthsLater.toISOString().slice(0, 10);
  return schedule.filter(d => d >= today && d <= cutoff);
}

// Counts dates in schedule that are >= today (YYYY-MM-DD comparison).
export function countRemainingCoupons(
  schedule: string[],
  today?: string
): number {
  const reference = today ?? new Date().toISOString().slice(0, 10);
  return schedule.filter((date) => date >= reference).length;
}
